import Vue from "vue";
import VueI18n from "vue-i18n";
import i18n from "@/modules/i18n";
import { Dictionary } from "@/types";

export function useOverride() {
  const origTC = i18n.tc;

  function pluralizationWrapper(
    this: any,
    key: VueI18n.Path,
    choice: VueI18n.Choice = 1,
    valuesOrLocale?: VueI18n.Locale | VueI18n.Values,
    values?: VueI18n.Values
  ): string {
    let tcFunc = origTC.bind(i18n) as (...args: any) => string;

    const getVal = (values: VueI18n.Values) => {
      let val: Dictionary<string> = { word: key };
      if (Array.isArray(values)) {
        values.forEach((item, index) => {
          val[index] = item;
        });
      } else {
        val = { ...val, ...values };
      }
      return val;
    };
    let locale: string | undefined;
    if (typeof valuesOrLocale === "string") {
      locale = valuesOrLocale;
      values = values || {};
    } else {
      values = valuesOrLocale || {};
    }

    if (locale) {
      return tcFunc(key, choice, locale, getVal(values));
    }
    const messages = i18n.messages[`${i18n.fallbackLocale}`];
    let path = "pl.word";
    if ((messages.pl as VueI18n.LocaleMessageObject)[key] !== undefined) {
      path = "pl." + key;
    }

    let result = tcFunc(path, choice, getVal(values));
    if (!Array.isArray(values) && values.withoutN === true) {
      result = result.replace(/^\d* /, "");
    }
    return result;
  }
  i18n.tc = Vue.prototype.$tc = pluralizationWrapper;
}

export const $t = (key: string, values?: any[] | Record<string, any>) => i18n.t(key, values) as string;

export function getCountryName(countryCode: string) {
  return $t(`$locations.${countryCode}`);
}

export function getStateName(stateCode: string, countryCode: string) {
  return $t(`$locations.${countryCode}___${stateCode}`);
}
